import { Dayjs } from "dayjs"
import moment from "moment"
import baseMoment, { Moment as MomentOrig } from "moment"
import { extendMoment } from "moment-range"
export const Moment = extendMoment(baseMoment as any)

export function FromDayJs(m: Dayjs): MomentOrig {
	return moment(m.toDate())
}
